import { render, staticRenderFns } from "./CodeContainer.vue?vue&type=template&id=891edc7a&scoped=true"
import script from "./CodeContainer.vue?vue&type=script&lang=js"
export * from "./CodeContainer.vue?vue&type=script&lang=js"
import style0 from "./CodeContainer.vue?vue&type=style&index=0&id=891edc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891edc7a",
  null
  
)

export default component.exports